import type { RouteObject } from "react-router";
import { replace } from "react-router";

/* Legacy routes redirected to new locations */
export const projectRedirects = [
  {
    path: "data/material-histories/*",
    loader: ({ request }) =>
      replace(request.url.replace("/material-histories/", "/materials/")),
  },
  {
    path: "datasets/:datasetId/data-objects/:dataObjectId/*",
    loader: ({ params }) =>
      replace(
        `/projects/${params.projectId}/data/materials/${params.dataObjectId}`,
      ),
  },
  {
    path: "data-sources/*",
    loader: ({ request }) =>
      replace(request.url.replace("/data-sources/", "/data/")),
  },
  {
    path: "material-histories/*",
    loader: ({ request }) =>
      replace(request.url.replace("/material-histories/", "/data/materials/")),
  },
  {
    path: "models/*",
    loader: ({ request }) =>
      replace(request.url.replace("/models/", "/predictors/")),
  },
  {
    path: "process-flows/*",
    loader: ({ request }) =>
      replace(request.url.replace("/process-flows/", "/data/materials/")),
  },
  {
    path: "search-scopes/*",
    loader: ({ request }) =>
      replace(request.url.replace("/search-scopes/", "/search-spaces/")),
  },
] as const satisfies RouteObject[];
